<template>
  <v-row>
    <v-col>
      <VAutocomplete
        v-model="selectedUser"
        :label="$t('forms.labels.user')"
        :items="displayedMember"
        @change="updateData"
      />
    </v-col>
  </v-row>
</template>

<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        currentUser: {
            type: String,
            default: '',
        },
        client: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            selectedUser: '',
            members: [],
        };
    },
    computed: {
        displayedMember() {
            return this.members.map(member => ({
                name: `${member.firstName} ${member.lastName}`,
                id: member.id,
            }));
        },
    },
    created() {
        this.selectedUser = this.currentUser;
        this.loadMember();
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.selectedUser);
        },
        async loadMember() {
            const { data } = await this.$rq.getClientMembers(this.client, { pagination: false });
            this.members = data.members;
        },
    },
};
</script>
